module.exports = __webpack_public_path__ + "static/media/mona_figure.438f6284.png";